export default {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 200,
    cursor: 'pointer',
  },
  wrapper: {
    backgroundColor: 'white',
    paddingRight: 17,
    paddingTop: 10,
    paddingBottom: 10,
    borderBottom: '1px solid #E2E2FC',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 16,
  },
  button: {
    backgroundColor: '#004360',
    color: 'white',
    width: 150,
    height: 50,
    fontSize: 16,
    whiteSpace: 'nowrap',
    '& + *': {
      marginLeft: 24,
    },
    '&:hover': {
      backgroundColor: '#004360',
    },
    textTransform: 'none',
    fontFamily: "'Proxima Nova Alt', sans-serif",
  },
  title: {
    fontFamily: "'Proxima Nova Alt', sans-serif",
    fontSize: 20,
    fontWeight: '700',
    color: '#011533',
    marginLeft: 10,
  },
  rotate180: {
    transform: 'rotate(180deg)',
  },
  upIcon: {
    marginBottom: 5,
  },
}
